<script>
  export let tic;
</script>

<svg
  class={tic}
  width="24"
  height="24"
  viewBox="0 0 24 24"
  stroke-width="2"
  stroke="currentColor"
  fill="none"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path stroke="none" d="M0 0h24v24H0z" />
  <rect x="3" y="4" width="18" height="16" rx="2" />
  <line x1="7" y1="8" x2="7" y2="8.01" />
  <line x1="12" y1="8" x2="12" y2="8.01" />
  <line x1="17" y1="8" x2="17" y2="8.01" />
  <line x1="7" y1="12" x2="7" y2="12.01" />
  <line x1="12" y1="12" x2="12" y2="12.01" />
  <line x1="17" y1="12" x2="17" y2="12.01" />
  <line x1="7" y1="16" x2="17" y2="16" /></svg
>
